/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { UpdateOnboardingChannelsApiArg, UpdateOnboardingDraftResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateOnboardingChannels: build.mutation<UpdateOnboardingDraftResponse, UpdateOnboardingChannelsApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/onboarding/channels`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateOnboardingChannelsApi };
export const { useUpdateOnboardingChannelsMutation } = injectedRtkApi;
